import { comicBookshelfGridClass, comicBookshelfItemClass } from '../../lib/comicBookshelfGrid'
import type { ComicProject } from '../../lib/comicTypes'
import { ThemeStagger, ThemeStaggerItem } from '../motion/ThemeMotion'
import { ComicBookCard } from './ComicBookCard'

type Props = {
  projects: ComicProject[]
  angular: boolean
  layoutReflow?: boolean
  onDeleteProject?: (project: ComicProject) => void
}

/**
 * 漫画书架栅格：固定列宽 auto-fill，一格一册。
 */
export function ComicBookshelf({ projects, angular, layoutReflow = true, onDeleteProject }: Props) {
  return (
    <ThemeStagger
      className={comicBookshelfGridClass}
      aria-label="漫画作品书架"
      singleChild={projects.length === 1}
    >
      {projects.map((project) => (
        <ThemeStaggerItem key={project.id} className={comicBookshelfItemClass} layoutReflow={layoutReflow}>
          <ComicBookCard project={project} angular={angular} onDelete={onDeleteProject} />
        </ThemeStaggerItem>
      ))}
    </ThemeStagger>
  )
}
